import PageHeader from "@/components/common/PageHeader";
import { usePlanManager } from "./hooks/usePlanManager";
import { PlanTable, PlanCreateForm } from "./components";

function PlanListPage() {
  const pm = usePlanManager();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Plans"
        subtitle="Configure pricing, limits, and trial settings."
      />

      <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 px-6 py-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h3 className="text-base font-semibold text-slate-900">
              Plan list
            </h3>
            <p className="text-sm text-slate-500">
              Review existing plans before creating a new one.
            </p>
          </div>
          <button
            type="button"
            onClick={() => pm.setShowCreateForm((prev) => !prev)}
            className="rounded-xl bg-slate-900 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white"
          >
            {pm.showCreateForm ? "Hide create form" : "Create new plan"}
          </button>
        </div>

        <PlanTable
          planRows={pm.planRows}
          isLoading={pm.isLoading}
          isUpdating={pm.isUpdating}
          updatePlan={pm.updatePlan}
        />
      </section>

      {pm.showCreateForm && (
        <PlanCreateForm
          form={pm.form}
          setForm={pm.setForm}
          showModuleSelector={pm.showModuleSelector}
          setShowModuleSelector={pm.setShowModuleSelector}
          moduleSearchTerm={pm.moduleSearchTerm}
          setModuleSearchTerm={pm.setModuleSearchTerm}
          modules={pm.modules}
          groupedModules={pm.groupedModules}
          toggleModule={pm.toggleModule}
          isCreating={pm.isCreating}
          handleSubmit={pm.handleSubmit}
          onClose={() => pm.setShowCreateForm(false)}
        />
      )}
    </div>
  );
}

export default PlanListPage;
